import {NotificationNumberResolver} from "./notification.resolver";
import {NgModule} from "@angular/core";
import {RouterModule, Routes} from "@angular/router";
import {CerbaCommonModule} from "@common/cerba-common.module";
import {EnsureUserAuthGuard, LogoutAuthGuard} from "@digicerba/common";
import {CanauxResolver} from "./pages/alertes/canaux/canaux.resolver";
import {GestionCanauxResolver} from "./pages/alertes/canaux/gestion-canaux.resolver";
import {EnregistrementCanalResolver} from "./pages/alertes/canaux/enregistrement/enregistrement.canaux.resolver";
import {TagsResolver} from "./pages/alertes/canaux/enregistrement/tags.resolver";
import {ResourceMultimediaPipe} from "@utils/image/resource.multimedia.pipe";
import {CanauxActifsUtilisateurResolver} from "./pages/alertes/canaux/canaux-actifs-utilisateur.resolver";
import {AsiDialogService, AsiFileService, AsiPaginationModule} from "@asi-ngtools/lib";
import {CerbaPageComponent} from "./cerba.component";
import {HeaderComponent} from "./header/header.component";
import {CanauxComponent} from "./pages/alertes/canaux/canaux.component";
import {EnregistrementCanalComponent} from "./pages/alertes/canaux/enregistrement/enregistrement.canaux.component";
import {ConsultationAlertesComponent} from "./pages/alertes/consultation/consultation.alertes.component";
import {FiltresConsultationAlertesComponent} from "./pages/alertes/consultation/filtres/filtres-consultation-alertes.component";
import {ResultatsAlertesComponent} from "./pages/alertes/consultation/resultats/resultats.alertes.component";
import {GestionAlertesComponent} from "./pages/alertes/canaux/gestion/gestion-alertes.component";
import {PublicationMessageComponent} from "./pages/alertes/message/publication/publication.message.component";
import {ModalComponent} from "./pages/alertes/message/publication/modal/modal.component";
import {AccessResolver} from "./check.resolver";
import {ConsultationEventManager} from "app/pages/cerba/pages/alertes/consultation/consultation.eventManger";
import {EnsureAdminAuthGuard} from "./pages/alertes/canaux/ensure-admin-auth.guard";
import {PublicationMessageResolver} from "./pages/alertes/message/publication/publication.message.resolver";
import {ProfilValideResolver} from "./profil-valide.resolver";

const cerbaRoutes: Routes = [
  {
    path: 'cerba',
    component: CerbaPageComponent,
    canActivate: [EnsureUserAuthGuard],
    resolve: {
      chack: AccessResolver,
      nbAlerts: NotificationNumberResolver,
      profilValide: ProfilValideResolver,
    },
    children: [
      { path: '', redirectTo: 'alertes', pathMatch: 'full' },
      {
        path: 'alertes', component: ConsultationAlertesComponent,
        resolve: { canauxActifsUtilisateur: CanauxActifsUtilisateurResolver }
      },
      {
        path: 'canaux', component: CanauxComponent,
        canActivate: [EnsureAdminAuthGuard],
        resolve: { canaux: CanauxResolver }
      },
      {
        path: 'enregistrement',
        canActivate: [EnsureAdminAuthGuard],
        children: [
          {
            path: 'canal', component: EnregistrementCanalComponent,
            resolve: { tags: TagsResolver }
          },
          {
            path: 'canal/:id', component: EnregistrementCanalComponent,
            resolve: { canal: EnregistrementCanalResolver, tags: TagsResolver }
          },
          {
            path: 'message', component: PublicationMessageComponent,
            resolve: { canaux: CanauxResolver, modules: PublicationMessageResolver }
          },
        ]
      },
      {
        path: 'gestion_alertes', component: GestionAlertesComponent,
        resolve: { canaux: GestionCanauxResolver }
      }
    ]
  },
  { path: 'logout', component: CerbaPageComponent, canActivate: [LogoutAuthGuard] },
  { path: '', redirectTo: 'cerba', pathMatch: 'full' }
];

@NgModule({
  declarations: [
    HeaderComponent,
    CerbaPageComponent,
    CanauxComponent,
    EnregistrementCanalComponent,
    ConsultationAlertesComponent,
    FiltresConsultationAlertesComponent,
    ResultatsAlertesComponent,
    GestionAlertesComponent,
    PublicationMessageComponent,
    ModalComponent
  ],
  entryComponents: [
    ModalComponent
  ],
    imports: [
        CerbaCommonModule,
        RouterModule.forRoot(cerbaRoutes, {useHash: true}),
        AsiPaginationModule,
    ],
  exports: [
    RouterModule
  ],
  providers: [
    AccessResolver,
    CanauxResolver,
    EnregistrementCanalResolver,
    ResourceMultimediaPipe,
    TagsResolver,
    CanauxActifsUtilisateurResolver,
    GestionCanauxResolver,
    AsiDialogService,
    AsiFileService,
    NotificationNumberResolver,
    ConsultationEventManager,
    EnsureAdminAuthGuard,
    PublicationMessageResolver,
    ProfilValideResolver
  ]
})
export class CerbaRoutingModule {
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-notifications/digicerba-notifications-web/src/angular/cerba/src/app/pages/cerba/cerba.router.ts